// Location map
let parsedAllpoints = [];
let map;
let allpointsMarkers = [];
let markers;

function initializeLocationsMap() {
  // Get location map elements
  const $locationList = $('[data-location-list]');
  const $locationListInfo = $('[data-location-list-info]');
  const $locations = $('[data-location]');
  const $locationMap = $('#location-map');
  const $locationSearchInput = $('#location-search');
  const $locationFindButton = $('#find-a-location');
  const $locationTypeCheckboxes = $('input[name="location-type[]"]');
  const $locationFeatureCheckboxes = $('input[name="location-feature[]"]');

  // Declare Google Maps objects
  let geocoder = new google.maps.Geocoder();

  // Declare object for storing location data, elements, and markers
  let locationsData;

  // Setup the location map if it exists on the page
  if ($locationMap.length > 0) {
    // Initialize location map on page load
    initializeMap();

    // Call find/filter locations on page load to reflect initial state
    findLocations();
    filterLocations();

    // Register keypress event on location controls
    $locationSearchInput.keydown(submitFindLocationsOnEnterKey);
    $locationTypeCheckboxes.keydown(submitFindLocationsOnEnterKey);
    $locationFeatureCheckboxes.keydown(submitFindLocationsOnEnterKey);

    // Register change event on location controls
    $locationFindButton.click(findLocations);
    $locationTypeCheckboxes.change(filterLocations);
    $locationFeatureCheckboxes.change(filterLocations);
  }

  // Initializes the map
  function initializeMap() {
    // Map marker icons
    const branchMarkerIcon = {
      url: '/frontend/dist/images/icons/map-marker-branch.png',
      labelOrigin: new google.maps.Point(17, 17),
    };
    const atmMarkerIcon = {
      url: '/frontend/dist/images/icons/map-marker-atm.png',
      labelOrigin: new google.maps.Point(17, 17),
    };

    // A single info window for displaying branch information when markers are clicked
    const infoWindow = new google.maps.InfoWindow();

    // The location of Florida
    const florida = { lat: 28.2299758, lng: -80.7094517 };

    // The map, centered at Florida
    map = new google.maps.Map($locationMap.get(0), {
      zoom: 11,
      center: florida,
      mapTypeControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    });

    //~~~~~~~~~~~~~~~~~~~~~~~~~~
    var soapMessage =
      '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi = "http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd = "http://www.w3.org/2001/XMLSchema" xmlns:soap = "http://schemas.xmlsoap.org/soap/envelope/"><soap:Body> <FindLocations xmlns="http://tempuri.org/"><UserName>7E08E1BB</UserName><Password>7E08E1BB-F497-47CD-9CA5-8E68CE225A32</Password>' +
      '<AddressLine></AddressLine><City></City><State></State><PostalCode></PostalCode><Country></Country><Latitude>' +
      florida.lat +
      '</Latitude><Longitude>' +
      florida.lng +
      '</Longitude><Type></Type><Offset></Offset></FindLocations></soap:Body></soap:Envelope>';
    getAllPoints(soapMessage);
    // Users Current Location
    // Try HTML5 geolocation.
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        geocoder.geocode({ location: pos }, (results, status) => {
          if (status === 'OK') {
            if (results[0]) {
              $('#location-search').val(results[0].formatted_address);
            }
          }
        });
        currLat = position.coords.latitude;
        currLng = position.coords.longitude;

        var soapMessage =
          '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi = "http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd = "http://www.w3.org/2001/XMLSchema" xmlns:soap = "http://schemas.xmlsoap.org/soap/envelope/"><soap:Body> <FindLocations xmlns="http://tempuri.org/"><UserName>7E08E1BB</UserName><Password>7E08E1BB-F497-47CD-9CA5-8E68CE225A32</Password>' +
          '<AddressLine></AddressLine><City></City><State></State><PostalCode></PostalCode><Country></Country><Latitude>' +
          currLat +
          '</Latitude><Longitude>' +
          currLng +
          '</Longitude><Type></Type><Offset></Offset></FindLocations></soap:Body></soap:Envelope>';

        getAllPoints(soapMessage);
        map.setCenter(pos);
      });
    }

    //~~~~~~~~~~~~~~~~~~~~~~~~~~

    // Create a marker for each location and add it to the map
    markers = $locations
      .map(function (index, domElement) {
        const locationDataJson = JSON.stringify($(domElement).data('location'));
        const locationData = JSON.parse(locationDataJson);

        let marker = new google.maps.Marker({
          position: locationData.position,
          map: map,
          icon: locationData.isBranch ? branchMarkerIcon : atmMarkerIcon,
          animation: google.maps.Animation.DROP,
          label: {
            color: locationData.isBranch ? '#fff' : '#000',
            fontFamily: 'Montserrat',
            fontWeight: '600',
            fontSize: '1rem',
            text: locationData.markerNumber.toString(),
          },
  
        });
        

        // When marker is clicked, display info window with location's info
        marker.addListener('click', function () {
          infoWindow.setContent(
            $(domElement).find('.location-list-info-window').html()
          );
          infoWindow.open(map, marker);
        });

        return marker;
      })
      .get();

    // Assign locations data
    locationsData = $locations
   
      .map(function (index, domElement) {
       
        return {
          data: $(domElement).data('location'),
          $element: $(domElement),
          marker: markers[index],
        };
      })
      .get();
  }

  // When enter key is pressed in the event, submit the find locations
  function submitFindLocationsOnEnterKey(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      findLocations();
    }
  }

  // Find locations
  function findLocations() {
    const locationSearchValue = $('#location-search').val();

    if (locationSearchValue) {
      var searchSoapMessage =
        '<?xml version="1.0" encoding="utf-8"?><soap:Envelope xmlns:xsi = "http://www.w3.org/2001/XMLSchema-instance" xmlns:xsd = "http://www.w3.org/2001/XMLSchema" xmlns:soap = "http://schemas.xmlsoap.org/soap/envelope/"><soap:Body> <FindLocations xmlns="http://tempuri.org/"><UserName>7E08E1BB</UserName><Password>7E08E1BB-F497-47CD-9CA5-8E68CE225A32</Password>' +
        '<AddressLine>' +
        locationSearchValue +
        '</AddressLine>' +
        '<City></City><State></State><PostalCode></PostalCode><Country></Country><Latitude></Latitude><Longitude></Longitude>' +
        '<Type></Type><Offset></Offset></FindLocations></soap:Body></soap:Envelope>';
      getAllPoints(searchSoapMessage);
      geocoder.geocode(
        { address: locationSearchValue },
        function (results, status) {
          if (status == 'OK') {
            const position = results[0].geometry.location;

            // Center map on position
            map.setCenter(position);
            map.setZoom(10);

            // Order locations by distance from position
            orderLocationsByDistance(position);
          } else {
            alert(
              'Geocode was not successful for the following reason: ' + status
            );
          }
        }
      );
    }
  }

  // Filter locations
  function filterLocations() {
    // Get selected checkboxes
    
    const locationTypes = $locationTypeCheckboxes
      .filter(':checked')
      .map(function () {
        return $(this).val();
      })
      .get();
    const locationFeatures = $locationFeatureCheckboxes
      .filter(':checked')
      .map(function () {
        return parseInt($(this).val());
      })
      .get();

    // Determine which locations should be shown based on checkboxes
    const shownLocationsData = locationsData
      .filter(
        (
          ld // Filter by location types
        ) =>
          (ld.data.isBranch && locationTypes.includes('branch')) ||
          (ld.data.isAtm && locationTypes.includes('atm'))
      )
      .filter(
        (
          ld // Filter by features
        ) => locationFeatures.every((lf) => ld.data.features.includes(lf))
      );
    const infoWindow = new google.maps.InfoWindow();
    // Only show locations that satisfy the filters
    locationsData.forEach((ld) => {
      ld.$element.hide();
      ld.marker.setVisible(false);
    });
    // Map marker icons
    const branchMarkerIcon = {
      url: '/frontend/dist/images/icons/map-marker-branch.png',
      labelOrigin: new google.maps.Point(17, 17),
    };
    const atmMarkerIcon = {
      url: '/frontend/dist/images/icons/map-marker-atm.png',
      labelOrigin: new google.maps.Point(17, 17),
    };
    shownLocationsData.forEach((ld) => {
      if (locationTypes.includes('branch') && locationTypes.includes('atm')) {
        if (ld.data.isBranch && ld.data.isAtm) {
          ld.marker.icon = branchMarkerIcon;
        }

      }
      if (!locationTypes.includes('branch') && locationTypes.includes('atm')) {
        if (ld.data.isBranch && ld.data.isAtm) {
          ld.marker.icon = atmMarkerIcon;
        }
      }
      if (locationTypes.includes('branch') && !locationTypes.includes('atm')) {
        if (ld.data.isBranch && ld.data.isAtm) {
          ld.marker.icon = branchMarkerIcon;
        }
      }
      
      //declaring temp variables
      let tempMarker = ld.marker
      let tempmarkerNumber = ld.data.markerNumber
      let tempElement = ld.$element

      let bName = tempElement.find('.location-list-info-window a').html();
     
      bName = bName.replace(/&amp;/g, '&');
      let areWeABranch = tempMarker.icon == branchMarkerIcon ? 'Branch' : 'ATM'
      let getBranchName = `Number ${ld.data.markerNumber } ${bName} ${areWeABranch}`;
    
      //clearing the markers
      ld.marker = null;
      //Creating new markers with updated icon
      ld.marker = new google.maps.Marker({
        icon: tempMarker.icon,
        position: tempMarker.position,
        index: tempmarkerNumber,
        map: map,
        optimized: false,
        title: getBranchName,
        visible:true,
        //label: tempmarkerNumber,
        label: {
          color: tempMarker.icon == branchMarkerIcon ? '#fff' : '#000',
          fontFamily: 'Montserrat',
          fontWeight: '600',
          fontSize: '1rem',
          text: `${tempmarkerNumber.toString() }`,
        },
      });

      /*$("div[title]").each(function () {
        console.log($(this).attr("title")); // Logs all titles
      });*/
      
      ld.marker.addListener('click', function () {
        infoWindow.setContent(
          tempElement.find('.location-list-info-window').html()
        );
        infoWindow.open(map, ld.marker);
      });
      ld.$element.show();
      ld.marker.setVisible(true);

    });

    if (!locationTypes.includes('sfatm')) {
      for (let marker in allpointsMarkers) {
        allpointsMarkers[marker].setMap(null);
      }
      //allpointsMarker = [];
    } else {
      showAllPointMarkers();
    }
    // Set location list info text
    $locationListInfo.text(
      `${$locationListInfo.data('location-list-text')}: ${
        shownLocationsData.length
      }`
    );
  }

  // Orders locations in the DOM based on distance from the specified position
  function orderLocationsByDistance(position) {
    // Sort locations
    const locationsByDistance = locationsData
      .map((ld) => {
        return {
          $element: ld.$element,
          distance: google.maps.geometry.spherical.computeDistanceBetween(
            position,
            ld.marker.getPosition()
          ),
        };
      })
      .sort((a, b) => a.distance - b.distance);

    // Detach and re-append locations in order of distance
    locationsByDistance.forEach((lbd) => {
      let $parent = lbd.$element.parent();
      lbd.$element.detach().appendTo($parent);
    });
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  initializeLocationsMap();

});

function getAllPoints(requestSoapMessage) {
  const $locationTypeCheckboxes = $('input[name="location-type[]"]');
  const locationTypes = $locationTypeCheckboxes
    .filter(':checked')
    .map(function () {
      return $(this).val();
    })
    .get();

  $.ajax({
    url: 'https://mobileapi.locatorsearch.com/LocatorSearchAPI.asmx',
    type: 'POST',
    dataType: 'xml',
    data: requestSoapMessage,
    //processData: false,
    contentType: 'text/xml; charset=utf-8',
    success: function (result) {
      $(result)
        .find('location')
        .each(function () {
          let mapUrl = '';
          let locationName = '';
          var allPointsInfoWindow = '';
          let allowedLocations = [
            'COSTCO',
            'CVS',
            'DUANE READE',
            'SPEEDWAY',
            'TARGET',
            'WALGREENS',
            'CUMBERLAND FARMS',
          ];

          $(this)
            .find('attribute')
            .each(function () {
              if ($(this).attr('key') == 'LocationName') {
                locationName = $(this).text();
              }
            });

          allPointsInfoWindow =
            '<div class="location-list-info-window">' +
            '<a href="https://maps.google.com/maps?daddr=' +
            $(this).find('address').find('street').text() +
            ' ' +
            $(this).find('address').find('city').text() +
            ' ' +
            $(this).find('address').find('state').text() +
            ' ' +
            $(this).find('address').find('zip').text() +
            '" class="d-inline-block font-size-large font-weight-bold mb-1">' +
            locationName +
            '</a>' +
            '<div class="mb-1">\
          <address>' +
            $(this).find('address').find('street').text() +
            '<br>' +
            $(this).find('address').find('city').text() +
            ', ' +
            $(this).find('address').find('state').text() +
            ' ' +
            $(this).find('address').find('zip').text() +
            '<br>' +
            '<em></em>\
          </address>\
          </div>';

          //var set = $(this).attr("key") + $(this).html();
          if (locationName.length >= 16) {
            locationName = locationName.substr(0, 16);
          }
          if (allowedLocations.indexOf(locationName.toUpperCase()) > -1) {
            //if(locationName=="Costco"||locationName=="CVS"||locationName=="Duane Reade"||locationName=="Speedway"||locationName=="Target"||locationName=="Walgreens"){
            parsedAllpoints.push([
              $(this).find('address').find('lat').text(),
              $(this).find('address').find('long').text(),
              allPointsInfoWindow,
            ]);
          }
        });

      if (locationTypes.indexOf('sfatm') > -1) {
        //$("#jsonParse").append(parsedAllpoints);
        showAllPointMarkers();
      }
    },
  });

  //  filterLocations();
  return true;
}

function showAllPointMarkers() {
  const infoWindow = new google.maps.InfoWindow();

  for (let i = 0; i < parsedAllpoints.length; i++) {
    let apInfoWindowText = parsedAllpoints[i][2];
    let apMarker = new google.maps.Marker({
      icon: '/frontend/dist/images/icons/allpoint-locations.png',
      position: new google.maps.LatLng(
        parsedAllpoints[i][0],
        parsedAllpoints[i][1]
      ),
      map: map,
    });

 
    apMarker.addListener('click', function () {
      infoWindow.setContent(apInfoWindowText);
      //infoWindow.position(apMarker.position);
      infoWindow.open(map, apMarker);
    });

    allpointsMarkers.push(apMarker);
  }
}

window.addEventListener('load', (event) => {
  
  console.log('Page is fully loaded');
  $('div[title]').removeAttr('title');
 
});





